window.PK_HANDLES={
 "The Princess|Dog Outfit Collection": {
  "one": "dog-the-princess",
  "two": null,
  "proof": null
 },
 "The Nurse|Dog Outfit Collection": {
  "one": "dog-the-nurse",
  "two": null,
  "proof": null
 },
 "The Ballet Dancer|Dog Outfit Collection": {
  "one": "dog-the-ballet-dancer",
  "two": null,
  "proof": null
 },
 "The Chef|Dog Outfit Collection": {
  "one": "dog-the-chef",
  "two": null,
  "proof": null
 },
 "The Pickleballer|Dog Outfit Collection": {
  "one": "dog-the-pickleballer",
  "two": null,
  "proof": null
 },
 "The Sailor|Dog Outfit Collection": {
  "one": "dog-the-sailor",
  "two": null,
  "proof": null
 },
 "The Cowgirl|Dog Outfit Collection": {
  "one": "dog-the-cowgirl",
  "two": null,
  "proof": null
 },
 "The Cowboy|Dog Outfit Collection": {
  "one": "dog-the-cowboy",
  "two": null,
  "proof": null
 },
 "The Angel|Dog Outfit Collection": {
  "one": "dog-the-angel",
  "two": null,
  "proof": null
 },
 "The Barking Champion|Dog Outfit Collection": {
  "one": "dog-the-barking-champion",
  "two": null,
  "proof": null
 },
 "The Boss|Dog Outfit Collection": {
  "one": "dog-the-boss",
  "two": null,
  "proof": null
 },
 "The Cheerleader|Dog Outfit Collection": {
  "one": "dog-the-cheerleader",
  "two": null,
  "proof": null
 },
 "The Clown|Dog Outfit Collection": {
  "one": "dog-the-clown",
  "two": null,
  "proof": null
 },
 "The Golfer|Dog Outfit Collection": {
  "one": "dog-the-golfer",
  "two": null,
  "proof": null
 },
 "The Lady|Dog Outfit Collection": {
  "one": "dog-the-lady",
  "two": null,
  "proof": null
 },
 "The Security Guard|Dog Outfit Collection": {
  "one": "dog-the-security-guard",
  "two": null,
  "proof": null
 },
 "The Yogi|Dog Outfit Collection": {
  "one": "dog-the-yogi",
  "two": null,
  "proof": null
 },
 "The King|Cat Outfit Collection": {
  "one": "cat-the-king",
  "two": null,
  "proof": null
 },
 "The Princess|Cat Outfit Collection": {
  "one": "cat-the-princess",
  "two": null,
  "proof": null
 },
 "The Nurse|Cat Outfit Collection": {
  "one": "cat-the-nurse",
  "two": null,
  "proof": null
 },
 "The Ballet Dancer|Cat Outfit Collection": {
  "one": "cat-the-ballet-dancer",
  "two": null,
  "proof": null
 },
 "The Chef|Cat Outfit Collection": {
  "one": "cat-the-chef",
  "two": null,
  "proof": null
 },
 "The Pickleballer|Cat Outfit Collection": {
  "one": "cat-the-pickleballer",
  "two": null,
  "proof": null
 },
 "The Sailor|Cat Outfit Collection": {
  "one": "cat-the-sailor",
  "two": null,
  "proof": null
 },
 "The Cowgirl|Cat Outfit Collection": {
  "one": "cat-the-cowgirl",
  "two": null,
  "proof": null
 },
 "The Cowboy|Cat Outfit Collection": {
  "one": "cat-the-cowboy",
  "two": null,
  "proof": null
 },
 "The Angel|Cat Outfit Collection": {
  "one": "cat-the-angel",
  "two": null,
  "proof": null
 },
 "The Boss|Cat Outfit Collection": {
  "one": "cat-the-boss",
  "two": null,
  "proof": null
 },
 "The Cheerleader|Cat Outfit Collection": {
  "one": "cat-the-cheerleader",
  "two": null,
  "proof": null
 },
 "The Clown|Cat Outfit Collection": {
  "one": "cat-the-clown",
  "two": null,
  "proof": null
 },
 "The Golfer|Cat Outfit Collection": {
  "one": "cat-the-golfer",
  "two": null,
  "proof": null
 },
 "The Security Guard|Cat Outfit Collection": {
  "one": "cat-the-security-guard",
  "two": null,
  "proof": null
 },
 "The Yogi|Cat Outfit Collection": {
  "one": "cat-the-yogi",
  "two": null,
  "proof": null
 },
 "The King|Dog Outfit Collection": {
  "one": "dog-the-king",
  "two": null,
  "proof": null
 },
 "Oil Painting Style Dog Portrait|Dog Portrait Series": {
  "one": "custom-dog-portrait-oil-painting-style",
  "two": "custom-two-dog-portrait-oil-painting-style",
  "proof": null
 },
 "Fashion Name Dog Portrait|Dog Portrait Series": {
  "one": "custom-dog-name-portrait-fashion-name",
  "two": null,
  "proof": null
 },
 "Watercolor Style Dog Portrait|Dog Portrait Series": {
  "one": "custom-dog-portrait-watercolor-style",
  "two": "custom-two-dog-portrait-watercolor-style",
  "proof": null
 },
 "Ink Style Dog Portrait|Dog Portrait Series": {
  "one": "custom-dog-portrait-ink-style",
  "two": "custom-two-dog-portrait-ink-style",
  "proof": null
 },
 "Oil Painting Style Cat Portrait|Cat Portrait Series": {
  "one": "custom-cat-portrait-oil-painting-style",
  "two": "custom-two-cat-portrait-oil-painting-style",
  "proof": null
 },
 "Fashion Name Cat Portrait|Cat Portrait Series": {
  "one": "custom-cat-name-portrait-fashion-name",
  "two": null,
  "proof": null
 },
 "Watercolor Style Cat Portrait|Cat Portrait Series": {
  "one": "custom-cat-portrait-watercolor-style",
  "two": "custom-two-cat-portrait-watercolor-style",
  "proof": null
 },
 "Ink Style Cat Portrait|Cat Portrait Series": {
  "one": "custom-cat-portrait-ink-style",
  "two": "custom-two-cat-portrait-ink-style",
  "proof": null
 },
 "Oil Painting Style Pet Parent & Dog|Pet Parent Series": {
  "one": "pet-parent-and-dog-portrait-oil-painting-style",
  "two": null,
  "proof": null
 },
 "Watercolor Style Pet Parent & Dog|Pet Parent Series": {
  "one": "pet-parent-and-dog-portrait-watercolor-style",
  "two": null,
  "proof": null
 },
 "Oil Painting Style Pet Parent & Cat|Pet Parent Series": {
  "one": "pet-parent-and-cat-portrait-oil-painting-style",
  "two": null,
  "proof": null
 },
 "Watercolor Style Pet Parent & Cat|Pet Parent Series": {
  "one": "pet-parent-and-cat-portrait-watercolor-style",
  "two": null,
  "proof": null
 },
 "Watercolor Style Engagement Portrait|Couples Series": {
  "one": "custom-engagement-portrait-watercolor-style",
  "two": null,
  "proof": null
 },
 "Watercolor Style Anniversary Portrait|Couples Series": {
  "one": "custom-anniversary-portrait-watercolor-style",
  "two": null,
  "proof": null
 },
 "Oil Painting Style Engagement Portrait|Couples Series": {
  "one": "custom-engagement-portrait-oil-painting-style",
  "two": null,
  "proof": null
 },
 "Ink Style Couple Portrait|Couples Series": {
  "one": "custom-couple-portrait-ink-style",
  "two": null,
  "proof": null
 },
 "Watercolor Style Best Friends Portrait|Best Friends Series": {
  "one": "best-friends-portrait-watercolor-style",
  "two": null,
  "proof": null
 },
 "Oil Painting Style Best Friends Portrait|Best Friends Series": {
  "one": "best-friends-portrait-oil-painting-style",
  "two": null,
  "proof": null
 },
 "Ink Style Best Friends Portrait|Best Friends Series": {
  "one": "best-friends-portrait-ink-style",
  "two": null,
  "proof": null
 },
 "Sticker Style Best Friends Portrait|Best Friends Series": {
  "one": "best-friends-sticker-portrait",
  "two": null,
  "proof": "all"
 },
 "Retro Arch Best Friends Portrait|Best Friends Series": {
  "one": "best-friends-portrait-arch",
  "two": null,
  "proof": "all"
 },
 "Our House|Home Series": {
  "one": "custom-one-home-portrait-watercolor-style",
  "two": null,
  "proof": null
 },
 "The Places We've Called Home: Two Homes|Home Series": {
  "one": "custom-two-homes-portrait-watercolor-style",
  "two": null,
  "proof": null
 },
 "The Places We've Called Home: Three Homes|Home Series": {
  "one": "custom-three-homes-portrait-watercolor-style",
  "two": null,
  "proof": null
 },
 "The Places We've Called Home: Four Homes|Home Series": {
  "one": "custom-four-homes-portrait-watercolor-style",
  "two": null,
  "proof": null
 },
 "Our House in Oil Painting Style|Home Series": {
  "one": "our-house-portrait-oil-painting-style",
  "two": null,
  "proof": null
 },
 "Yosemite National Park Portrait|National Park Collection": {
  "one": "yosemite-national-park-photo-portrait",
  "two": null,
  "proof": null
 },
 "Acadia National Park Portrait|National Park Collection": {
  "one": "acadia-national-park-photo-portrait",
  "two": null,
  "proof": null
 },
 "Zion National Park Portrait|National Park Collection": {
  "one": "zion-national-park-photo-portrait",
  "two": null,
  "proof": null
 },
 "Cuyahoga Valley National Park Portrait|National Park Collection": {
  "one": "cuyahoga-valley-national-park-photo-portrait",
  "two": null,
  "proof": null
 },
 "Joshua Tree National Park Portrait|National Park Collection": {
  "one": "joshua-tree-national-park-photo-portrait",
  "two": null,
  "proof": null
 },
 "Yellowstone National Park Portrait|National Park Collection": {
  "one": "yellowstone-national-park-photo-portrait",
  "two": null,
  "proof": null
 },
 "Grand Teton National Park Portrait|National Park Collection": {
  "one": "grand-teton-national-park-photo-portrait",
  "two": null,
  "proof": null
 },
 "Rocky Mountain National Park Portrait|National Park Collection": {
  "one": "rocky-mountain-national-park-photo-portrait",
  "two": null,
  "proof": null
 },
 "Glacier National Park Portrait|National Park Collection": {
  "one": "glacier-national-park-photo-portrait",
  "two": null,
  "proof": null
 },
 "Great Smoky Mountains National Park Portrait|National Park Collection": {
  "one": "great-smoky-mountains-national-park-photo-portrait",
  "two": null,
  "proof": null
 },
 "Grand Canyon National Park Portrait|National Park Collection": {
  "one": "grand-canyon-national-park-photo-portrait",
  "two": null,
  "proof": null
 },
 "Olympic National Park Portrait|National Park Collection": {
  "one": "olympic-national-park-photo-portrait",
  "two": null,
  "proof": null
 },
 "Map Photo|Map Series": {
  "one": "custom-map-photo-print",
  "two": null,
  "proof": null
 },
 "Map View|Map Series": {
  "one": "custom-map-view-print",
  "two": null,
  "proof": null
 }
};